import { WS_COMMANDS as WSC } from "./websocketCommands";
import { selectStudentStatusById, updateStudentStatus } from "../store/administrationSlice";
import { selectStudentStatusById as contentSelectStudentStatusById, selectPinnedBoard, contentUpdateAllStudents, setPinnedBoard, contentUpdateStudentStatus, setIsPresenting, selectIsPresenting, selectPreviewBoardMode, setPreviewBoardMode, setIsShowAssignInfoPopper, selectIsGameRefreshed } from "../store/contentSlice";
import { studioSelectStudentStatusById, studioUpdateAllStudents, studioUpdateStudentStatus, selectPreviewSelectedActivity, setPreviewSelectedActivity } from "../store/studioSlice";
import { wsSelectStudentStatusById, wsSelectAllStudentsStatus, wsUpdateStudentStatus } from "../store/websocketSlice";
import { chatSelectStudentStatusById, chatUpdateStudentStatus, sendChatMessage } from "../store/chatSlice";
import { selectTreatment, pushStudentsToNewTreatment, setDrawingValue, setIsParticipentDrawing, setUserStatuses, setIsParticipantUpdating } from "../store/treatmentServerDataSlice";
import { WS_STUDENT_LIVE_CHECK_INTERVAL, WS_STUDENT_LIVE_CHECK_TOLERANCE, PREVIEW_BOARD_ID, TECH_INDICATIONS, SECOND } from "../constants";
import { h5pGamesUpdateStudentStatus, h5pGamesSelectStudentStatusById, H5PWebsocketUpdate, setPreviewH5PGame, selectPreviewH5PGame, H5PPreviewWebsocketUpdate, selectPreviewH5PPostMessageHandler, selectH5PGameByStudentId, setIsPreviewH5PGameDone, selectIsMultiStudentGame, h5pGamesSelectAllStudentsStatus } from "../store/h5pGamesSlice";
import { articulationUpdateStudentStatus, sendWordToStudent, sendWordUUIDToStudent, articulationSelectStudentStatusById } from "../store/articulationSlice";
import { speechUpdateStudentStatus, speechSelectStudentStatusById } from "../store/speechSlice";
import { videoUpdateStudentStatus, setIsVideoPaused, videoUpdateAllStudents, setIsVideoMuted, selectIsVideoMuted, selectIsVideoPaused, videoSelectAllStudentsStatus } from "../store/videoSlice";
import { youtubeSelectStudentStatusById, youtubeUpdateAllStudents, youtubeUpdateStudentStatus } from "../store/youtubeSlice";
import { READING_REDUCERS, updateStudentReadingStatus, sendReadingToWS, readingSelectStudentStatusById } from "@app/routes/activities/reading/store/readingSlice";
import { sendSpellingToWS, getSpellingReducerByType, spellingSelectStudentStatusById, selectPreviewSpellingStatus } from "@app/routes/activities/spelling/store/spellingSlice";
import { PRESENTING_BOARD_ID as SPELLING_PRESENTING_BOARD_ID } from "@app/routes/activities/spelling/constants";
import { CHAT_SENDER_POSITION, CHAT_RECEIVER_POSITION, CHAT_WIDGET_STATUS as CWS } from "@app/routes/treatmentV3/components/chat/ChatUtils";
import { techStatusSelectStudentStatusById, techStatusUpdateStudentStatus, assignActivity } from "../store/techStatusSlice";
import { initErrorList } from "@amplio-common/funcs/techStatusFunc";
import { activityPressAction } from "@app/routes/treatmentV3/store/contentThunks";
import { TREATMENT_STATUSES } from "@app/constants";
import { currentUser } from "@amplio-common/selectors/auth";

const relevantMessages = {
  [WSC.LIVE_CHECK_REQ]: (websocket) => websocket.send(JSON.stringify({ command: WSC.LIVE_CHECK_RESPONSE })),
  [WSC.REQUEST_CURRENT_CONTENT]: (websocket, payload) => {
    const studentId = payload?.content?.user_id;
    if (!studentId) { return; }
    const state = websocket.reduxStore.getState();
    
    const contentStudentStatus = contentSelectStudentStatusById(state, studentId) || {};
    const studioStudentStatus = studioSelectStudentStatusById(state, studentId) || {};
    const h5pStudentStatus = h5pGamesSelectStudentStatusById(state, studentId) || {};
    const articulationStatus = articulationSelectStudentStatusById(state, studentId) || {};
    const youtubeStatus = youtubeSelectStudentStatusById(state, studentId) || {};
    const readingStatus = readingSelectStudentStatusById(state, studentId) || {};
    const spellingStatus = spellingSelectStudentStatusById(state, studentId) || {};
    const chatStatus = chatSelectStudentStatusById(state, studentId) || {};
    const isPresenting = selectIsPresenting(state);
    const previewMode = selectPreviewBoardMode(state);
    const previewStudioActivity = selectPreviewSelectedActivity(state);
    const previewH5PGame = selectPreviewH5PGame(state);
    const previewSpelling = selectPreviewSpellingStatus(state, SPELLING_PRESENTING_BOARD_ID) || {};
    const isTeacherVideoMuted = selectIsVideoMuted(state);
    const isTeacherVideoPaused = selectIsVideoPaused(state);
    
    const { boardMode } = contentStudentStatus;
    const { selectedActivity } = studioStudentStatus;
    const { h5pGame } = h5pStudentStatus;
    const { studentSelectedWord } = articulationStatus;
    const { videoId } = youtubeStatus;
    const { messageList } = chatStatus;
    const alteredMessageList = messageList?.map(msg => ({ ...msg, position: msg.position === CHAT_SENDER_POSITION ? CHAT_RECEIVER_POSITION : CHAT_SENDER_POSITION }));
    const studentNumOfUnreadChatMessage = messageList?.filter(msg => msg?.position === CHAT_SENDER_POSITION && !msg?.messageReadByOtherSide)?.length || 0;

    boardMode && websocket.sendJson({ command: WSC.SET_STUDENT_BOARD, newMode: boardMode, target_user: studentId });
    selectedActivity && websocket.sendJson({ command: WSC.SET_STUDENT_ACTIVITY, selectedActivity, target_user: studentId });
    h5pGame?.id && websocket.sendJson({ command: WSC.SET_H5P_GAME, h5pGame: JSON.stringify(h5pGame), target_user: studentId });

    isPresenting && websocket.sendJson({ command: WSC.SET_TEACHER_PRESENTING, isTeacherPresenting: true, target_user: studentId });
    previewMode && websocket.sendJson({ command: WSC.SET_PREVIEW_MODE, mode: previewMode, target_user: studentId });
    readingStatus && websocket?.sendJson({ command: WSC.READING_SEND_STATUS, status: readingStatus, target_user: studentId });
    spellingStatus && websocket?.sendJson({ command: WSC.SPELLING_SEND_STATUS, status: spellingStatus, target_user: studentId });
    previewSpelling && websocket?.sendJson({ command: WSC.SPELLING_SEND_PREVIEW_STATUS, status: previewSpelling, target_user: studentId });
    previewStudioActivity && websocket.sendJson({ command: WSC.SET_PREVIEW_STUDIO_ACTVITY, previewActivity: previewStudioActivity, target_user: studentId });
    previewH5PGame?.id && websocket.sendJson({ command: WSC.SET_PREVIEW_H5P_GAME, h5pGame: JSON.stringify(previewH5PGame), target_user: studentId });
    studentSelectedWord && websocket.sendJson({ command: WSC.SEND_ARTICULATION_WORD, target_user: studentId, articulationWord: studentSelectedWord });
    videoId && websocket.sendJson({ command: WSC.SET_YOUTUBE_VIDEO_ID, videoId, target_user: studentId });
    websocket.sendJson({ command: WSC.CHAT_GET_MESSAGE_LIST, messageList: alteredMessageList, target_user: studentId, numUnreadMessage: studentNumOfUnreadChatMessage });
    isTeacherVideoMuted && websocket.sendJson({ command: WSC.TOGGLE_TEACHER_MUTE, isTeacherVideoMuted, target_user: studentId });
    isTeacherVideoPaused && websocket.sendJson({ command: WSC.TOGGLE_TEACHER_VIDEO_PAUSE, isTeacherVideoPaused, target_user: studentId });
    websocket?.sendJson({ command: WSC.WELCOME_STUDENT_VIDEO_STATS, target_user: studentId }); //request video status
    websocket.sendJson({ command: WSC.IS_TEACHER_CONNECTED, isConnected: true, target_user: studentId });
  },
  [WSC.UPDATE_USERS]: (websocket, payload) => {
    websocket.reduxStore.dispatch(setUserStatuses(payload.content.content));
  },
  [WSC.STUDENT_CURRENT_STATUS]: (websocket, payload) => {
    const { user_id: studentId, isVideoOn, isVideoMuted, isVideoPaused, isVideoApproved, isVideoPending } = payload?.content || {}; //currently used to update video stats
    websocket.reduxStore.dispatch(videoUpdateStudentStatus({ id: studentId, changes: { isVideoOn, isVideoMuted, isVideoPaused, isVideoApproved, isVideoPending } }));
  },
  [WSC.SEND_S2T_RESULT]: (websocket, payload) => {
    const state = websocket.reduxStore.getState();
    const data = payload.content?.data;
    const studentId = payload?.content?.user_id;
    const student = speechSelectStudentStatusById(state, studentId);
    const { speechAnalysisResults, isSpeechLocked } = student || {};
    let changes;
    if (!isSpeechLocked) {
      changes = { speechAnalysisResults: { tags: data?.tags, ttr: data?.metrics?.ttr, details: data?.details } };
    } else if (speechAnalysisResults?.tags) {
      changes = { speechAnalysisResults: {} };
    } else {
      return;
    }
    payload.content?.s2tResult && websocket.reduxStore.dispatch(speechUpdateStudentStatus({ id: studentId, changes }));
  },
  [WSC.SEND_IS_RECORDING]: (websocket, payload) => {
    const state = websocket.reduxStore.getState();
    const studentId = payload?.content?.user_id;
    const student = articulationSelectStudentStatusById(state, studentId);
    const { isStudentRecording } = student || {};
    const isRecording = payload.content?.isStudentRecording;
    if (isRecording != null) {
      const changes = { isRecording, isEnabledRecording: isRecording, recordingStartTime: isRecording ? new Date().getTime() : null };
      let articulationChanges = { isStudentRecording: isRecording };
      if (!isRecording && isStudentRecording) {
        articulationChanges = { ...articulationChanges, studentSelectedWord: null };
      }
      websocket.reduxStore.dispatch(articulationUpdateStudentStatus({ id: studentId, changes: articulationChanges }));
      websocket.reduxStore.dispatch(speechUpdateStudentStatus({ id: studentId, changes }));
    }
  },
  [WSC.H5P_GAME_UPDATE]: (websocket, payload) => {
    const { user_id: studentId, data } = payload.content;
    const s = websocket.reduxStore.getState();
    const isGroupMode = selectIsMultiStudentGame(s);
    if (isGroupMode) {
      const boards = h5pGamesSelectAllStudentsStatus(s);
      boards.forEach(board => {
        h5pGamesSelectStudentStatusById(s, board.id).h5pGamePostMessageHandler(data);
      });
    }
    h5pGamesSelectStudentStatusById(s, studentId).h5pGamePostMessageHandler(data);
  },
  [WSC.H5P_GAME_PREVIEW_UPDATE]: (websocket, payload) => {
    const { data } = payload.content;
    const s = websocket.reduxStore.getState();
    selectPreviewH5PPostMessageHandler(s)(data);
  },
  [WSC.H5P_RE_ASSIGN_CURRENT_GAME]: (websocket, payload) => {
    const s = websocket.reduxStore.getState();
    const studentId = payload?.content?.user_id;
    const h5pGame = selectH5PGameByStudentId(s, studentId);
    h5pGame?.game && websocket.reduxStore.dispatch(activityPressAction({
      game: h5pGame.game,
      fromFilterDialog: !!h5pGame.filters,
      isPreview: false,
      selectedStudents: [studentId],
      source: "try-again-button-student",
    }));
  },
  [WSC.TOGGLE_STUDENT_MUTE_BY_STUDENT]: (websocket, payload) => {
    const studentId = payload?.content?.user_id;
    websocket.reduxStore.dispatch(videoUpdateStudentStatus({ id: studentId, changes: { isVideoMuted: payload?.content?.isVideoMuted } }));
  },
  [WSC.TOGGLE_STUDENT_PAUSE_BY_STUDENT]: (websocket, payload) => {
    const studentId = payload?.content?.user_id;
    websocket.reduxStore.dispatch(videoUpdateStudentStatus({ id: studentId, changes: { isVideoPaused: payload?.content?.isVideoPaused } }));
  },
  [WSC.SEND_ARTICULATION_WORD]: (websocket, payload) => {
    const studentId = payload?.content?.user_id;
    const articulationWordDialog = payload?.content?.articulationWordDialog;

    websocket.reduxStore.dispatch(articulationUpdateStudentStatus({ id: studentId, changes: { studentSelectedWord: articulationWordDialog } }));
  },
  [WSC.IS_YOUTUBE_PLAYING]: (websocket, payload) => {
    const { user_id: studentId, isPlaying } = payload.content;
    websocket.reduxStore.dispatch(youtubeUpdateStudentStatus({ id: studentId, changes: { isPlaying }, src: "ws" }));
  },
  [WSC.YOUTUBE_SKIPPED_TIME]: (websocket, payload) => {
    const { user_id: studentId, skippedTime } = payload.content;
    websocket.reduxStore.dispatch(youtubeUpdateStudentStatus({ id: studentId, changes: { skippedTime }, src: "ws" }));
  },
  [WSC.IS_ENDED_YOUTUBE_VIDEO]: (websocket, payload) => {
    const { user_id: studentId, isEnded } = payload.content;
    websocket.reduxStore.dispatch(youtubeUpdateStudentStatus({ id: studentId, changes: { isEnded } }));
  },
  [WSC.IS_ERROR_YOUTUBE_VIDEO]: (websocket, payload) => {
    const { user_id: studentId, isError } = payload.content;
    websocket.reduxStore.dispatch(youtubeUpdateStudentStatus({ id: studentId, changes: { isError } }));
  },
  [WSC.SEND_RECORDINGS_COUNT]: (websocket, payload) => {
    const studentId = payload?.content?.user_id;
    const recordingsCount = payload?.content?.recordingsCount;
    let changes = { recordingsCount, speechAnalysisResults: {} };
    if (recordingsCount === 0) {
      changes = { ...changes, isRecording: false, isEnabledRecording: false };
    }
    websocket.reduxStore.dispatch(speechUpdateStudentStatus({ id: studentId, changes }));
  },
  [WSC.SPEECH_SEND_UUID]: (websocket, payload) => {
    const uuid = payload?.content?.uuid;
    const studentId = payload?.content?.user_id;
    websocket.reduxStore.dispatch(speechUpdateStudentStatus({ id: studentId, changes: { speechUUID: uuid } }));
  },

  // Reading
  [WSC.READING_GENERIC_SEND]: (websocket, payload) => {
    const data = payload?.content?.data;
    const reducer = READING_REDUCERS[data?.reducerType];
    reducer && websocket.reduxStore.dispatch(reducer(data));
  },
  [WSC.READING_CLEAR_STATE]: (websocket, payload) => {
    const studentId = payload?.content?.user_id;
    websocket.reduxStore.dispatch(updateStudentReadingStatus({ id: studentId, changes: { requiredClearState: true } }));
  },

  // Spelling
  [WSC.SPELLING_GENERIC_SEND]: (websocket, payload) => {
    const data = payload?.content?.data;
    const reducer = getSpellingReducerByType(data?.reducerType);
    reducer && websocket.reduxStore.dispatch(reducer(data));
  },

  //CHAT
  [WSC.CHAT_NEW_MESSAGE]: (websocket, payload) => {
    const { newMessage, user_id: studentId } = payload?.content || {};
    const s = websocket.reduxStore.getState();
    const chatStudentStatus = chatSelectStudentStatusById(s, studentId);
    const prevMessageList = chatStudentStatus?.messageList;
    const prevNumUnreadMessages = chatStudentStatus?.numUnreadMessages;
    const chatWidgetStatus = chatStudentStatus?.chatWidgetStatus;
    const newNumUnreadMessages = chatWidgetStatus === CWS.OPEN ? prevNumUnreadMessages : prevNumUnreadMessages + 1;
    const changes = { messageList: [...prevMessageList, { ...newMessage, position: CHAT_RECEIVER_POSITION }],
      numUnreadMessages: newNumUnreadMessages };
    websocket.reduxStore.dispatch(chatUpdateStudentStatus({ id: studentId, changes }));
  },
  [WSC.CHAT_WIDGET_OPENED]: (websocket, payload) => {
    const { user_id: studentId } = payload?.content || {};
    const s = websocket.reduxStore.getState();
    const chatStudentStatus = chatSelectStudentStatusById(s, studentId);
    const prevMessageList = chatStudentStatus?.messageList;
    const changes = { messageList: prevMessageList.map(msg => ({ ...msg,
      messageReadByOtherSide:
      msg.position === CHAT_SENDER_POSITION ? true : msg.messageReadByOtherSide })) };
    websocket.reduxStore.dispatch(chatUpdateStudentStatus({ id: studentId, changes }));
  },
  // tech stat
  [WSC.TECH_INIT_STATUS]: (websocket, payload) => {
    const studentId = payload?.content?.user_id;
    const initStatus = payload?.content?.initStatus;
    websocket.reduxStore.dispatch(techStatusUpdateStudentStatus({ id: studentId,
      changes: { ...initStatus } }));
  },
  [WSC.TECH_INIT_ERRORS]: (websocket, payload) => {
    const studentId = payload?.content?.user_id;
    const errorList = payload?.content?.errorList;
    websocket.reduxStore.dispatch(techStatusUpdateStudentStatus({ id: studentId,
      changes: { errorList } }));
  },
  [WSC.TECH_WINDOW_FOCUS_STATUS]: (websocket, payload) => {
    const studentId = payload?.content?.user_id;
    const isWindowFocused = payload?.content?.isWindowFocused;
    websocket.reduxStore.dispatch(techStatusUpdateStudentStatus({ id: studentId, changes: { isWindowFocused } }));
  },
  [WSC.TECH_WINDOW_VISIBILITY_STATUS]: (websocket, payload) => {
    const studentId = payload?.content?.user_id;
    const isTabVisible = payload?.content?.isTabVisible;

    const s = websocket.reduxStore.getState();
    const { errorList } = techStatusSelectStudentStatusById(s, studentId) || { errorList: initErrorList };
    websocket.reduxStore.dispatch(techStatusUpdateStudentStatus({ id: studentId,
      changes: { isTabVisible, errorList: { ...errorList, [TECH_INDICATIONS.USER_FOCUS]: { isActive: !isTabVisible } } } }));
  },
  [WSC.TECH_AUDIO_PERMISSIONS]: (websocket, payload) => {
    const studentId = payload?.content?.user_id;
    const isAudioPermissionGranted = payload?.content?.isAudioPermissionGranted;
    const s = websocket.reduxStore.getState();
    const { errorList } = techStatusSelectStudentStatusById(s, studentId) || { errorList: initErrorList };
    websocket.reduxStore.dispatch(techStatusUpdateStudentStatus({ id: studentId,
      changes: { isAudioPermissionGranted, errorList: { ...errorList, [TECH_INDICATIONS.PERMISSIONS]: { isActive: !isAudioPermissionGranted } } } }));
  },
  [WSC.TECH_VIDEO_PERMISSIONS]: (websocket, payload) => {
    const studentId = payload?.content?.user_id;
    const isVideoPermissionGranted = payload?.content?.isVideoPermissionGranted;
    const s = websocket.reduxStore.getState();
    const { errorList } = techStatusSelectStudentStatusById(s, studentId) || { errorList: initErrorList };
    const isPermissionErr = errorList[TECH_INDICATIONS.PERMISSIONS]?.isActive;
    websocket.reduxStore.dispatch(techStatusUpdateStudentStatus({ id: studentId,
      changes: { isVideoPermissionGranted, errorList: { ...errorList, [TECH_INDICATIONS.PERMISSIONS]: { isActive: !isVideoPermissionGranted || isPermissionErr } } } }));
  },
  [WSC.TECH_OPENTOK_ERROR]: (websocket, payload) => {
    const studentId = payload?.content?.user_id;
    const studentOpentokError = payload?.content?.studentOpentokError;
    websocket.reduxStore.dispatch(techStatusUpdateStudentStatus({ id: studentId, changes: { studentOpentokError } }));
  },
  [WSC.SET_H5P_GAME]: (websocket, payload) => {
    const h5pGame = JSON.parse(payload?.content?.h5pGame);
    const studentId = payload?.content?.target_user;
    const uuid = h5pGame?.uuid;
    websocket.reduxStore.dispatch(h5pGamesUpdateStudentStatus({ id: studentId, changes: { h5pGame: { ...h5pGame, uuid } }, src: "ws" }));
  },
  [WSC.WHITEBOARD_UPDATE]: (websocket, payload) => {
    websocket.reduxStore.dispatch(setDrawingValue(payload.content.data));
    websocket.reduxStore.dispatch(setIsParticipantUpdating(payload.content.data.updating));
    websocket.reduxStore.dispatch(setIsParticipentDrawing(payload.content.isControlled));
  },
};

const websocketSimpleSend = (cmd, fieldName) => (state, action, websocket) => { websocket?.sendJson({ command: cmd, [fieldName]: action.payload }); };

const relevatActions = {
  [sendWordToStudent]: (state, action, websocket) => {
    const studentId = selectPinnedBoard(state);
    websocket.sendJson({ command: WSC.SEND_ARTICULATION_WORD, target_user: studentId === PREVIEW_BOARD_ID ? undefined : studentId, articulationWord: action.payload });
  },
  [h5pGamesUpdateStudentStatus]: (state, action, websocket) => {
    const { id, changes, src } = action?.payload || {};
    const isGameRefreshed = selectIsGameRefreshed(state);
    const isMultiStudent = selectIsMultiStudentGame(state);

    if (changes?.isH5PGameDone !== undefined && src !== "ws") {
      websocket.sendJson({ command: WSC.SET_IS_H5P_GAME_DONE, isH5PGameDone: changes?.isH5PGameDone, target_user: id });
    }

    if ((changes?.h5pGame?.isLoaded && src !== "ws")) {
      websocket.sendJson({
        command: WSC.SET_H5P_GAME,
        h5pGame: JSON.stringify(changes.h5pGame),
        target_user: id,
        isGameRefreshed,
        isGroupMode: isMultiStudent,
        token: `${localStorage.getItem("access_token")}`,
      });
    }

    if ((changes?.h5pGame?.isLoaded === false && src !== "ws")) {
      websocket.sendJson({
        command: WSC.SET_H5P_GAME,
        h5pGame: JSON.stringify({ id: null, uuid: null, type: null, isLoaded: false }),
        target_user: id,
      });
    }
  },

  [pushStudentsToNewTreatment]: websocketSimpleSend(WSC.PUSH_STUDNET, "pushStudent"),

  [sendWordUUIDToStudent]: (state, action, websocket) => {
    const { id, uuid, item } = action?.payload;
    uuid && websocket.sendJson({ command: WSC.SET_WORD_UUID, target_user: id, authData: { id, uuid }, articulationWord: item });
  },
  // [setIsPresenting]: websocketSimpleSend(WSC.SET_TEACHER_PRESENTING, "isTeacherPresenting"),
  [setIsPresenting]: (state, action, websocket) => {
    if (!state.treatmentContentSlice.isShareScreenOn) {
      websocket.sendJson({ command: WSC.SET_TEACHER_PRESENTING, isTeacherPresenting: action.payload });
    }
  },
  [setPreviewBoardMode]: websocketSimpleSend(WSC.SET_PREVIEW_MODE, "mode"),
  //video
  [videoUpdateStudentStatus]: (state, action, websocket) => {
    const { id, changes } = action?.payload || {};
    if (!changes) { return; } // no changes ?
    const allStudentStatus = videoSelectAllStudentsStatus(state);

    const isUpdateClosingVideo = changes.isVideoOn === false;

    const acceptedStudents = allStudentStatus
      .filter(student => (
        student.isVideoApproved || (id === student.id && changes.isVideoApproved)
      ))
      .map(student => student.id);
    acceptedStudents.forEach(student => {
      websocket.sendJson({ command: WSC.UPDATE_PARTICIPANTS, target_user: student, studentsConnected: acceptedStudents });
    });

    changes.isVideoPending && websocket.sendJson({ command: WSC.ASK_VIDEO_START, target_user: id, isVideoPending: changes.isVideoPending });

    !isUpdateClosingVideo && websocket.sendJson({ command: WSC.TOGGLE_STUDENT_MUTE_BY_TEACHER,
      target_user: id });

    !isUpdateClosingVideo && changes.isVideoPausedByTeacher != null && websocket.sendJson({ command: WSC.TOGGLE_STUDENT_PAUSE_BY_TEACHER,
      target_user: id,
      isVideoPausedByTeacher: changes.isVideoPausedByTeacher });

    changes.isExitVideo && websocket.sendJson({ command: WSC.VIDEO_RESET_STUDENT,
      target_user: id,
      isExitVideo: changes.isExitVideo });
  
    changes.isKickedFromVideo != null && websocket.sendJson({ command: WSC.VIDEO_KICK_STUDENT,
      target_user: id,
      isKickedFromVideo: changes.isKickedFromVideo });
  },

  [studioUpdateStudentStatus]: (state, action, websocket) => {
    const { id, changes/*, src*/ } = action?.payload || {};
    if (!changes) { return; } // no changes ?
    
    if (changes.loadedActivity) {
      const selectedStudioActivity = studioSelectStudentStatusById(state, id).loadedActivity;
      websocket.sendJson({ command: WSC.SET_STUDENT_ACTIVITY, target_user: id, activity: selectedStudioActivity });
    }

    changes?.selectedActivity && websocket.sendJson({ command: WSC.SET_STUDENT_ACTIVITY, target_user: id, selectedActivity: changes.selectedActivity });
  },
  [articulationUpdateStudentStatus]: (state, action, websocket) => {
    const { id, changes/*, src*/ } = action?.payload || {};
    if (!changes) { return; } // no changes ?
    
    if (changes.result != null) {
      websocket.sendJson({ command: WSC.SEND_ARTICULATION_RESULT, target_user: id, articulationResult: changes.result });
    }
  },
  [contentUpdateStudentStatus]: (state, action, websocket) => {
    const { id, changes } = action?.payload || {};
    if (!changes) { return; }
    changes?.isLocked !== undefined && websocket.sendJson({ command: WSC.SET_IS_LOCKED, target_user: id, isLocked: changes.isLocked });
    changes?.boardMode && websocket.sendJson({ command: WSC.SET_STUDENT_BOARD, target_user: id, newMode: changes.boardMode });
  },

  [contentUpdateAllStudents]: (state, action, websocket) => {
    // const { changes } = action?.payload?.[0] || {};
    // changes?.boardMode && websocket.sendJson({ command: WSC.SET_STUDENT_BOARD, newMode: changes.boardMode });
    const studentIds = action?.payload || [];
    studentIds.forEach(studentStatus => {
      const { id, changes, status_id } = studentStatus || {};
      changes?.boardMode && websocket.sendJson({ command: WSC.SET_STUDENT_BOARD, target_user: id, newMode: changes.boardMode });
      status_id === TREATMENT_STATUSES.DONE.id && websocket.sendJson({ command: WSC.SESSION_COMPLETED, target_user: id, sessionStatus: status_id });
    });
  },
  [youtubeUpdateAllStudents]: (state, action, websocket) => {
    // const { changes } = action?.payload?.[0] || {};
    // changes?.videoId && websocket.sendJson({ command: WSC.SET_YOUTUBE_VIDEO_ID, videoId: changes.videoId });
    const studentIds = action?.payload || [];
    studentIds.forEach(studentStatus => {
      const { id, changes } = studentStatus || {};
      changes?.videoId && websocket.sendJson({ command: WSC.SET_YOUTUBE_VIDEO_ID, target_user: id, videoId: changes.videoId });
    });
  },

  [youtubeUpdateStudentStatus]: (state, action, websocket) => {
    const { id, changes, src, studentId } = action?.payload || {};

    changes?.videoId && websocket.sendJson({ command: WSC.SET_YOUTUBE_VIDEO_ID, videoId: changes.videoId, target_user: studentId });
    src !== "ws" && changes?.skippedTime && websocket.sendJson({ command: WSC.YOUTUBE_SKIPPED_TIME, target_user: id, skippedTime: changes.skippedTime });
    src !== "ws" && changes?.isPlaying != null && websocket.sendJson({ command: WSC.IS_YOUTUBE_PLAYING, target_user: id, isPlaying: changes.isPlaying });
  },

  [H5PWebsocketUpdate]: (state, action, websocket) => {
    const { boardId, data } = action.payload;
    const multiStudent = selectIsMultiStudentGame(state);
    // console.log(data.cmd)
    if (multiStudent && data.cmd !== "initialSyncActions" && data.cmd !== "initialSyncReq") {
      const currUser = currentUser(state);
      data.playerName = currUser.first_name;
      websocket?.sendJson({ command: WSC.H5P_GAME_UPDATE, data, target_user: undefined });
      return;
    }
    websocket?.sendJson({ command: WSC.H5P_GAME_UPDATE, data, target_user: boardId });
  },
  [H5PPreviewWebsocketUpdate]: (state, action, websocket) => {
    const { data } = action.payload;
    websocket?.sendJson({ command: WSC.H5P_GAME_PREVIEW_UPDATE, data });
  },
  // [setViewAllBoards]: websocketSimpleSend(WSC.TOGGLE_PINNED_BOARD, "isSoloWork"),
  
  [videoUpdateAllStudents]: (state, action, websocket) => {
    const { changes } = action?.payload?.[0] || {};
    if (!changes) { return; } // no changes
    changes.isExitVideo && websocket.sendJson({ command: WSC.VIDEO_RESET_STUDENT, isExitVideo: changes.isExitVideo });
    changes.isTeacherVideoPaused !== null && websocket.sendJson({ command: WSC.TOGGLE_TEACHER_VIDEO_PAUSE,
      isTeacherVideoPaused: changes.isTeacherVideoPaused });
    changes.isTeacherVideoMuted !== null && websocket.sendJson({ command: WSC.TOGGLE_TEACHER_MUTE,
      isTeacherVideoMuted: changes.isTeacherVideoMuted });
  },

  [studioUpdateAllStudents]: (state, action, websocket) => {
    // const { changes } = action?.payload?.[0] || {};
    // changes?.selectedActivity && websocket.sendJson({ command: WSC.SET_STUDENT_ACTIVITY, selectedActivity: changes.selectedActivity });
    const studentIds = action?.payload || [];
    studentIds.forEach(studentStatus => {
      const { id, changes } = studentStatus || {};
      changes?.selectedActivity && websocket.sendJson({ command: WSC.SET_STUDENT_ACTIVITY, target_user: id, selectedActivity: changes.selectedActivity });
    });
  },
  [setIsVideoPaused]: websocketSimpleSend(WSC.TOGGLE_TEACHER_VIDEO_PAUSE, "isTeacherVideoPaused"),
  [setIsVideoMuted]: websocketSimpleSend(WSC.TOGGLE_TEACHER_MUTE, "isTeacherVideoMuted"),
  [setPreviewSelectedActivity]: websocketSimpleSend(WSC.SET_PREVIEW_STUDIO_ACTVITY, "previewActivity"),
  [setPreviewH5PGame]: (state, action, websocket) => {
    if (action.payload?.isLoaded) {
      websocket?.sendJson({ command: WSC.SET_PREVIEW_H5P_GAME, h5pGame: JSON.stringify(action.payload) });
    }
  },
  [setIsPreviewH5PGameDone]: (state, action, websocket) => {
    websocket?.sendJson({ command: WSC.SET_IS_PREVIEW_H5P_GAME_DONE, isH5PGameDone: action.payload });
  },

  // Reading
  [sendReadingToWS]: (state, action, websocket) => {
    const { boardId } = action.payload;
    websocket?.sendJson({ command: WSC.READING_GENERIC_SEND, data: action.payload, target_user: boardId > 0 ? boardId : undefined });
  },
  // Spelling
  [sendSpellingToWS]: (state, action, websocket) => {
    const { boardId } = action.payload;
    websocket?.sendJson({ command: WSC.SPELLING_GENERIC_SEND, data: action.payload, target_user: boardId > 0 ? boardId : undefined });
  },
  //ttr
  [speechUpdateStudentStatus]: (state, action, websocket) => {
    const { changes, id } = action?.payload || {};
    if (changes?.reset != null) {
      websocket?.sendJson({ command: WSC.SPEECH_CLEAR_STATE, target_user: id });
    }
    if (changes?.isEnabledRecording != null) {
      websocket?.sendJson({ command: WSC.SPEECH_TOGGLE_ENABLE_RECORDING, changes, target_user: id });
    }
    if (changes?.forceStop === true) {
      websocket?.sendJson({ command: WSC.SPEECH_TOGGLE_ENABLE_RECORDING, changes, target_user: id });
    }
  },
  //chat
  [sendChatMessage]: (state, action, websocket) => {
    const { newMessage, targetUserId: studentId } = action?.payload || {};
    if (action.payload) {
      const prevMessageList = chatSelectStudentStatusById(state, studentId)?.messageList;
      const changes = { messageList: [...prevMessageList, { ...newMessage, position: CHAT_SENDER_POSITION, messageReadByOtherSide: false }] };
      websocket.reduxStore.dispatch(chatUpdateStudentStatus({ id: studentId, changes }));
      websocket?.sendJson({ command: WSC.CHAT_NEW_MESSAGE, target_user: studentId, newMessage });
    }
  },
  [assignActivity]: (state, action, websocket) => {
    const studentId = action?.payload;
    websocket.sendJson({ command: WSC.TECH_ASSIGN_ACTIVITY, target_user: studentId });
  },
};


export const handleCheckStudentConnectedStatus = (websocket) => {
  const reduxState = websocket.reduxStore.getState();

  const allStudentsWS = wsSelectAllStudentsStatus(reduxState);
  const nowTime = new Date().getTime();

  allStudentsWS.forEach(studentStatus => {
    const { id: studentId, wsConnected } = studentStatus;
    const lastSeen = studentStatus.lastSeenDate;
    if (!lastSeen) {
      websocket.sendJson({ command: WSC.LIVE_CHECK_REQ, target_user: studentId });
      return;
    }

    const msDiff = nowTime - lastSeen;
    if (msDiff <= WS_STUDENT_LIVE_CHECK_INTERVAL) { return; } // all OK. skip.

    websocket.sendJson({ command: WSC.LIVE_CHECK_REQ, target_user: studentId }); // ask confirm for livechek
    if (msDiff > WS_STUDENT_LIVE_CHECK_TOLERANCE && wsConnected) {
      const changes = { wsConnected: false };
      const state = websocket.reduxStore.getState();
      const { assignInfoStudentId } = state.treatmentContentSlice;
      assignInfoStudentId === studentId && websocket.reduxStore.dispatch(setIsShowAssignInfoPopper(false));
      websocket.reduxStore.dispatch(wsUpdateStudentStatus({ id: studentId, changes }));

      selectPinnedBoard(reduxState) === studentId && websocket.reduxStore.dispatch(setPinnedBoard({ newBoardId: PREVIEW_BOARD_ID }));
      websocket.reduxStore.dispatch(articulationUpdateStudentStatus({ id: studentId, changes: { studentSelectedWord: null, isShowArticulationDialog: false } }));
    }
  });
};

const updateActualStart = (store, state, sentById) => {
  const treatment = selectTreatment(state);

  // Using this as temp for now:
  store.dispatch(updateStudentStatus({ id: sentById, changes: { actualStart: treatment.start_date } }));
};

const handleStudentLastSeenStatus = (store, state, sentById) => {
  const studentStatus = selectStudentStatusById(state, sentById);
  const wsStudentStatus = wsSelectStudentStatusById(state, sentById);
  if (!wsStudentStatus) { return; }

  const nowTS = new Date().getTime();
  nowTS - (SECOND * 2) > wsStudentStatus.lastSeenDate && store.dispatch(wsUpdateStudentStatus({ id: sentById, changes: { lastSeenDate: nowTS } }));

  if (!wsStudentStatus.wsConnected) {
    store.dispatch(wsUpdateStudentStatus({ id: sentById, changes: { wsConnected: true } }));
    store.dispatch(updateStudentStatus({ id: sentById, changes: { isArrived: true } }));
    // toast.info(`${studentStatus.name} connected`, { autoClose: 2500, position: "top-center" });
  }

  !studentStatus.actualStart && updateActualStart(store, state, sentById);
};

export const handleTherapistWSMessage = (websocket, payload) => {
  const { reduxStore } = websocket;
  const reduxState = reduxStore.getState();

  const { content = {} } = payload;
  const { command = "", user_id: sentById } = content;
  if (command !== WSC.SEND_S2T_RESULT) { handleStudentLastSeenStatus(reduxStore, reduxState, sentById); }
  relevantMessages[command]?.(websocket, payload);
};

export const handleTherapsitTreatmentActions = (state, action, websocket) => {
  relevatActions[action?.type]?.(state, action, websocket);
};
